import { connect } from 'react-redux'

import AtendimentoFinanceiro from '../../components/AtendimentoFinanceiro'

const mapStateToProps = (store) => ({
  agendamento: store.avaliacaoState.agendamento,
})

export default connect(mapStateToProps, null)(AtendimentoFinanceiro)
